import { SearchAPI } from "$lib/api/search";
import { searchStore, searchHistoryStore } from "$lib/stores";
import { SEARCH_PROGRESS } from "$lib/types";
import type { SearchInfo, SearchResult } from "$lib/types";

const INITIAL_POLLING_INTERVAL = 1500;
const EXTENDED_POLLING_INTERVAL = 4000;
const RESULTS_PER_FETCH = 40;

export class SearchPolling {
  private searchPollingInterval: NodeJS.Timeout | null = null;

  async pollSearchUpdates(searchId: string, slug: string, isLoggedIn: boolean, userId?: string) {
    try {
      const metadata = await SearchAPI.getSearchMetadataBySlug(slug, isLoggedIn, userId);

      if (!metadata) {
        this.stopPolling(slug);
        return;
      }

      const totalResults = (metadata.definiteMatch || 0) + (metadata.partialMatch || 0);
      searchStore.updateSearch(slug, metadata);
      searchHistoryStore.updateSearch(slug, {
        matchesCount: totalResults,
        updatedAt: new Date(),
      });

      const search = searchStore.getSearch(slug);

      // const displayedResults = (search?.results?.length || 0);

      // const lastId = currentResults.length > 0 ? String(currentResults[currentResults.length - 1].id) : null;

      // let pollOffset = displayedResults - (RESULTS_PER_FETCH - 10);
      // if (pollOffset < 0) {
      //   pollOffset = 0;
      // }

      // if (totalResults > displayedResults) {
      // const newResults = await SearchAPI.getSearchResultsByID(
      //     searchId,
      //     RESULTS_PER_FETCH,
      //     pollOffset,
      //     isLoggedIn,
      //     userId
      // );

      // if (search && newResults) {
      // searchStore.mergeResults(search.slug, newResults);
      // const updatedSearch = searchStore.getSearch(slug);
      // onResultsUpdate(newResults);
      // searchHistoryStore.updateSearch(slug, {
      //   matchesCount: updatedSearch.definiteMatch || 0 + (updatedSearch.partialMatch || 0),
      //   updatedAt: new Date(),
      // });

      // if (displayedResults === 0) {
      //   this.adjustPollingInterval(searchId, slug, isLoggedIn, userId);
      // }
      // }
      // }

      // Handle search status
      if (search.searchStatus === "processing" || search.searchStatus === "expanding") {
        // onProgressUpdate(SEARCH_PROGRESS.IN_PROGRESS);
        searchStore.updateSearch(slug, {
          searchStatus: "processing",
        });
        searchHistoryStore.updateSearch(slug, {
          searchStatus: "processing",
          updatedAt: new Date(),
        });
      } else if (search.searchStatus === "completed") {
        // onProgressUpdate(SEARCH_PROGRESS.FINISHED);
        searchStore.updateSearch(slug, {
          searchStatus: "completed",
        });
        searchHistoryStore.updateSearch(slug, {
          searchStatus: "completed",
          // matchesCount: totalResults,
          updatedAt: new Date(),
        });
        this.stopPolling(slug);
      }
    } catch (error) {
      console.error("Error in polling updates:", error);
      // Don't stop polling on error, let it retry
    }
  }

  // async pollSearchUpdates(
  //   searchId: string,
  //   slug: string,
  //   isLoggedIn: boolean,
  //   userId: string | undefined,
  //   currentSearch: SearchInfo | undefined,
  //   onProgressUpdate: (progress: typeof SEARCH_PROGRESS[keyof typeof SEARCH_PROGRESS]) => void,
  //   onResultsUpdate: (results: SearchResult[]) => void
  // ) {
  //   try {
  //     // const metadata = await SearchAPI.getSearchMetadataBySlug(slug, isLoggedIn, userId);

  //     // if (!metadata) {
  //     //   this.stopPolling(slug);
  //     //   return;
  //     // }

  //     // searchStore.updateSearch(slug, metadata);

  //     // const totalMatches = (metadata.definiteMatch || 0) + (metadata.partialMatch || 0);
  //     // searchHistoryStore.updateSearch(slug, {
  //     //   matchesCount: totalMatches,
  //     //   updatedAt: new Date(),
  //     // });

  //     // const currentResults = currentSearch?.results || [];

  //     // if (totalMatches > currentResults.length) {
  //     //   const newResults = await SearchAPI.getSearchResultsByID(
  //     //     searchId,
  //     //     RESULTS_PER_FETCH,
  //     //     currentResults.length,
  //     //     isLoggedIn,
  //     //     userId
  //     //   );

  //     //   if (currentSearch && newResults && newResults.length > 0) {
  //     //     searchStore.mergeResults(currentSearch.slug, newResults);
  //     //     onResultsUpdate(newResults);

  //     //     if (currentResults.length === 0) {
  //     //       this.adjustPollingInterval(searchId, slug, isLoggedIn, userId, currentSearch, onProgressUpdate, onResultsUpdate);
  //     //     }
  //     //   }
  //     // }

  //     const metadata = await SearchAPI.getSearchMetadataBySlug(slug, isLoggedIn, userId);

  //     if (!metadata) {
  //       this.stopPolling(slug);
  //       return;
  //     }

  //     searchStore.updateSearch(slug, metadata);

  //     const totalMatches = (metadata.definiteMatch || 0) + (metadata.partialMatch || 0);
  //     // searchHistoryStore.updateSearch(slug, {
  //     //   matchesCount: totalMatches,
  //     //   updatedAt: new Date(),
  //     // });

  //     const currentResults = currentSearch?.results || [];
  //     const lastId = currentResults.length > 0 ? currentResults[currentResults.length - 1].id : null;

  //     if (totalMatches > currentResults.length) {
  //       const newResults = await SearchAPI.getSearchResultsWithCursor(
  //         searchId,
  //         lastId,
  //         RESULTS_PER_FETCH,
  //         isLoggedIn,
  //         userId,
  //       );

  //       if (currentSearch && newResults && newResults.length > 0) {
  //         searchStore.mergeResults(currentSearch.slug, newResults);
  //         onResultsUpdate(newResults);

  //         if (currentResults.length === 0) {
  //           this.adjustPollingInterval(searchId, slug, isLoggedIn, userId, currentSearch, onProgressUpdate, onResultsUpdate);
  //         }
  //       }
  //     }

  //     if (metadata.searchStatus === "processing" || metadata.searchStatus === "expanding") {
  //       onProgressUpdate(SEARCH_PROGRESS.IN_PROGRESS);
  //     } else {
  //       onProgressUpdate(SEARCH_PROGRESS.FINISHED);
  //     }

  //     if (metadata.searchStatus === "completed") {
  //       onProgressUpdate(SEARCH_PROGRESS.FINISHED);
  //       searchHistoryStore.updateSearch(slug, {
  //         searchStatus: "completed",
  //         updatedAt: new Date(),
  //       });
  //       this.stopPolling(slug);
  //     }
  //   } catch (error) {
  //     console.error("Error in polling updates:", error);
  //   }
  // }

  startPolling(
    searchId: string,
    slug: string,
    isLoggedIn: boolean,
    userId: string | undefined,
    currentSearch: SearchInfo | undefined,
  ) {
    if (this.searchPollingInterval) {
      this.stopPolling(slug);
    }

    const currentResults = currentSearch?.results || [];
    const initialInterval = currentResults.length > 0 ? EXTENDED_POLLING_INTERVAL : INITIAL_POLLING_INTERVAL;

    this.searchPollingInterval = setInterval(() => {
      this.pollSearchUpdates(searchId, slug, isLoggedIn, userId);
    }, initialInterval);

    this.pollSearchUpdates(searchId, slug, isLoggedIn, userId);
  }

  private adjustPollingInterval(searchId: string, slug: string, isLoggedIn: boolean, userId: string | undefined) {
    if (this.searchPollingInterval) {
      clearInterval(this.searchPollingInterval);
    }
    this.searchPollingInterval = setInterval(() => {
      this.pollSearchUpdates(searchId, slug, isLoggedIn, userId);
    }, EXTENDED_POLLING_INTERVAL);
  }

  stopPolling(slug: string) {
    if (this.searchPollingInterval) {
      searchStore.updateSearch(slug, {
        ...searchStore.getSearch(slug),
        progressStatus: SEARCH_PROGRESS.FINISHED,
      });
      clearInterval(this.searchPollingInterval);
      this.searchPollingInterval = null;
    }
  }
}
